import { h, Host } from "@stencil/core";
export class ZoomWindow {
    onproductZoomChangedHandler(event) {
        this.image = event.detail.image;
        this.imageProperties = event.detail.imageProperties;
    }
    render() {
        let imageStyles = {};
        if (this.imageProperties) {
            imageStyles = {
                width: this.imageProperties.width,
                height: this.imageProperties.height,
                padding: this.imageProperties.padding,
                top: this.imageProperties.top,
                left: this.imageProperties.left
            };
        }
        return h(Host, { key: '81c07434ca7b68db48407e664642dbc51e0852ac' }, h("img", { key: '31ddbbe52db5b94b3e3a8e5b3ab032dc89838725', class: "zoomed-image", src: this.image, style: imageStyles, loading: 'lazy' }));
    }
    static get is() { return "uvex-zoom-window"; }
    static get states() {
        return {
            "image": {},
            "imageProperties": {}
        };
    }
    static get listeners() {
        return [{
                "name": "productZoomChanged",
                "method": "onproductZoomChangedHandler",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=zoom-window.js.map
